"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _reactToastify = require("react-toastify");

var _formik = require("formik");

var _WalletFastDepositSlider = _interopRequireDefault(require("./WalletFastDepositSlider"));

var _fastDepositSchema = _interopRequireDefault(require("./fastDepositSchema"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n  margin: 0 1rem 1rem;\n  border-radius: ", ";\n  box-shadow: ", ";\n  transition: background 0.25s;\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.boxShadowCard || "none";
}, function (props) {
  return props.isError ? props.theme.colorDanger : props.step === 2 ? "white" : props.theme.colorSuccess;
}, function (p) {
  return p.step === 2 ? p.theme.colorText : p.theme.colorSuccessText;
});

var StyledSliderWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 50%;\n  padding-left: 0.5rem;\n  padding-right: 1.5rem;\n"])));

var StyledButton = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1 1 60%;\n  max-width: 60%;\n  min-width: 60%;\n  width: 60%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 0;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: ", ";\n  cursor: pointer;\n"])), function (p) {
  return p.theme.borderRadius;
});

var StyledStep1 = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem;\n  padding-left: 1rem;\n  transform: translateY(", ");\n  transition: transform 0.25s;\n"])), function (props) {
  return props.step === 1 ? "0" : "100%";
});

var StyledStep2 = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-left: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transform: translateY(", ");\n  transition: transform 0.25s;\n"])), function (props) {
  return props.step === 1 ? "-100%" : "0";
});

var StyledPassword = _styledComponents.default.input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid ", ";\n  margin-right: 0.75rem;\n  min-width: 1px;\n  line-height: 40px;\n  font-size: 1rem;\n  transform: translateX(", ");\n  transition: transform 0.25s;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), function (p) {
  return p.theme.colorBorder;
}, function (props) {
  return props.step === 3 ? "-100%" : "0";
}, function (p) {
  return p.theme.colorLabel;
}, function (p) {
  return (0, _polished.darken)(0.1, p.theme.colorBorder);
});

var StyledDepositButton = _styledComponents.default.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: 0 1rem;\n  height: 2.5rem;\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n  min-width: 150px;\n  font-size: 0.875rem;\n  border-radius: ", ";\n  color: ", ";\n  white-space: nowrap;\n\n  &:disabled {\n    cursor: not-allowed;\n    background: ", ";\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.colorSuccess;
}, function (p) {
  return p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.colorSuccessText;
}, function (p) {
  return p.theme.colorDisabledBackground;
}, function (p) {
  return p.theme.colorDisabledText;
});

var StyledFormTextbox = (0, _styledComponents.default)(_fiverReactUiComponents.FormTextbox)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: 2.35rem;\n"])));

var StyledCancelButton = _styledComponents.default.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 0;\n\n  & > span {\n    color: ", ";\n    font-size: 30px;\n  }\n\n  margin-right: 0.5rem;\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledFastDeposit = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-align: left;\n  margin: 0 0.5rem 0 1rem;\n  white-space: nowrap;\n"])));

var StyledDepositValue = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  font-size: 1.375rem;\n  margin-right: 0.5rem;\n"])));

var StyledArrowIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-right: 1rem;\n"])));

var FastDepositButton = function FastDepositButton(_ref) {
  var onError = _ref.onError,
      getWallet = _ref.getWallet,
      translations = _ref.translations,
      _ref$currencySymbol = _ref.currencySymbol,
      currencySymbol = _ref$currencySymbol === void 0 ? "£" : _ref$currencySymbol,
      setTransactionsUpdated = _ref.setTransactionsUpdated;

  var _useState = (0, _react.useState)({
    step: 1,
    isError: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var step = state.step,
      isError = state.isError;

  var nextStep = function nextStep(e) {
    e.stopPropagation();

    if (step < 2) {
      var _nextStep = step + 1;

      setState(_objectSpread(_objectSpread({}, state), {}, {
        step: _nextStep
      }));
    }
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var setSubmitting, resetForm, _response$data, _response$data$errors, _response$data2, response, _response$data3;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref2.setSubmitting, resetForm = _ref2.resetForm;
              _context.prev = 1;
              _context.next = 4;
              return _axios.default.post("/wallet/deposit", {
                password: values.password,
                amount: +values.amount * 100
              });

            case 4:
              setTimeout(function () {
                setTransactionsUpdated(true);
                getWallet();

                _reactToastify.toast.success("Deposit success");

                window.xtremepush("tag", "Wallet.FastDeposit", JSON.stringify({
                  AppName: process.env.REACT_APP_TITLE
                }));
                setState(_objectSpread(_objectSpread({}, state), {}, {
                  step: 1
                }));
                setSubmitting(false);
                resetForm();
              }, 3000);
              _context.next = 13;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              response = _context.t0.response;
              onError(response);

              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$errors = _response$data.errors) !== null && _response$data$errors !== void 0 && _response$data$errors.password) {
                _reactToastify.toast.error("".concat(translations.password, " ").concat(translations.invalid));
              } else if (response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.message) {
                _reactToastify.toast.error(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.message);
              } else {
                _reactToastify.toast.error("Server Error");
              } //setState({ ...state, step: 1 });


              setSubmitting(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    validationSchema: (0, _fastDepositSchema.default)(translations),
    onSubmit: onSubmit,
    initialValues: {
      amount: "15.00",
      password: ""
    }
  }, function (_ref5) {
    var isSubmitting = _ref5.isSubmitting,
        isValid = _ref5.isValid,
        values = _ref5.values,
        errors = _ref5.errors,
        dirty = _ref5.dirty,
        handleChange = _ref5.handleChange,
        handleBlur = _ref5.handleBlur,
        setFieldValue = _ref5.setFieldValue,
        resetForm = _ref5.resetForm;
    return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
      step: step,
      isError: isError
    }, /*#__PURE__*/_react.default.createElement(StyledStep1, {
      step: step
    }, /*#__PURE__*/_react.default.createElement(StyledSliderWrapper, null, /*#__PURE__*/_react.default.createElement(_WalletFastDepositSlider.default, {
      setFieldValue: setFieldValue,
      value: values.amount
    })), /*#__PURE__*/_react.default.createElement(StyledButton, {
      onClick: nextStep
    }, /*#__PURE__*/_react.default.createElement(StyledFastDeposit, null, "Fast", /*#__PURE__*/_react.default.createElement("br", null), " Deposit"), /*#__PURE__*/_react.default.createElement(StyledDepositValue, null, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontSize: "60%",
        marginRight: "2px"
      }
    }, currencySymbol), values.amount), /*#__PURE__*/_react.default.createElement(StyledArrowIcon, {
      size: "24px"
    }, "arrow_forward_ios"))), /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(StyledStep2, {
      step: step
    }, /*#__PURE__*/_react.default.createElement(StyledCancelButton, {
      type: "button",
      onClick: function onClick() {
        resetForm();
        setState(_objectSpread(_objectSpread({}, state), {}, {
          step: 1
        }));
      }
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.MatIcon, null, "close")), step === 2 && /*#__PURE__*/_react.default.createElement(StyledFormTextbox, {
      step: step,
      name: "password",
      isError: dirty && errors.password,
      onChange: handleChange,
      value: values.password,
      autoFocus: true,
      placeholder: "Password",
      type: "password"
    }), /*#__PURE__*/_react.default.createElement(StyledDepositButton, {
      disabled: isSubmitting || !isValid || !dirty,
      step: step,
      isValid: isValid
    }, isSubmitting ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Spinner, {
      forDark: true,
      lineWidth: 3
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Deposit ", currencySymbol, values.amount)))));
  });
};

var _default = FastDepositButton;
exports.default = _default;